import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteProspectNavCardFragment = contentfulGql`#graphql
  ${imageFragment}
  fragment EntWebsiteProspectNavCard on EntWebsiteProspectNavCard {
    sys {
      id
    }
    headline
    description
    eyebrow
    ctaText
    ctaTarget
    shouldOpenTargetInNewWindow
    image {
      ...Image
    }
  }
`;

export const entWebsiteProspectNavFragment = contentfulGql`#graphql
  ${entWebsiteProspectNavCardFragment}
  fragment EntWebsiteProspectNav on EntWebsiteProspectNav {
    slug
    headline
    description
    cardsCollection {
      items {
        ...EntWebsiteProspectNavCard
      }
    }
  }
`;

export const entWebsiteBlockProspectNavQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteProspectNavFragment}
  query entWebsiteBlockProspectNav($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteProspectNav
      }
    }
  }
`;
